import { VIDEO_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const videoInitialState = {
  data: [],
  video: {},
  formError: {},
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function videoReducer(state = videoInitialState, action) {
  switch (action.type) {
    case VIDEO_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
